module.exports = __webpack_public_path__ + "static/hero-real-53c8dc93eac77ebaf2983eefdea5deb0.jpg";